module.exports = __webpack_public_path__ + "img/4499.ae360872.jpg";